import React, { useEffect, useState } from "react";

import classNames from "classnames";

import styles from "./pagination.module.scss";
interface PaginationProps {
  className?: string;
  pageCount?: number;
  pageSize?: number;
  page?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  onPageCountChange?: (pageCount: number) => void;
}
export const Pagination: React.FC<PaginationProps> = ({
  className,
  pageCount = 1,
  pageSize: initialPageSize = 20,
  page: initialPage = 1,
  onPageChange,
  onPageSizeChange,
  onPageCountChange,
}) => {
  const [page, setPageValue] = useState(initialPage);
  const [pageSize, setPageSizeValue] = useState(initialPageSize);

  useEffect(() => {
    if (onPageChange) onPageChange(page);
  }, [page, onPageChange]);

  useEffect(() => {
    if (onPageSizeChange) onPageSizeChange(pageSize);
  }, [pageSize, onPageSizeChange]);

  useEffect(() => {
    if (onPageCountChange) onPageCountChange(pageCount);
  }, [pageCount, onPageCountChange]);

  const stepsButtonClass = classNames(styles.steps_button, "my-4");
  const paginationClass = classNames(styles.pagination_container, className);
  const pageIndexClass = classNames(
    styles.page_button,
    styles.page_active_button
  );
 
  return (
    <div
      className={paginationClass}
      style={{ display: pageCount <= 1 ? " none" : "flex" }}
    >
      {page !== 1 && (
        <button className={styles.page_button} onClick={() => setPageValue(1)}>
          {"<<"}
        </button>
      )}
      <button
        className={stepsButtonClass}
        disabled={page === 1}
        onClick={() => setPageValue(page - 1)}
      >
        قبلی
      </button>
      {page - 2 > 0 && (
        <button
          className={styles.page_button}
          onClick={() => setPageValue(page - 2)}
        >
          {page - 2}
        </button>
      )}

      {page - 1 > 0 && (
        <button
          className={styles.page_button}
          onClick={() => setPageValue(page - 1)}
        >
          {page - 1}
        </button>
      )}
      <button className={pageIndexClass}>{page}</button>
      {page + 1 <= pageCount && (
        <button
          className={styles.page_button}
          onClick={() => setPageValue(page + 1)}
        >
          {page + 1}
        </button>
      )}
      {page + 2 <= pageCount && (
        <button
          className={styles.page_button}
          onClick={() => setPageValue(page + 2)}
        >
          {page + 2}
        </button>
      )}
      <button
        className={stepsButtonClass}
        disabled={page >= pageCount}
        onClick={() => setPageValue(page + 1)}
      >
        بعدی
      </button>
      {page < pageCount && (
        <button
          className={styles.page_button}
          onClick={() => setPageValue(pageCount)}
        >
          {">>"}
        </button>
      )}
    </div>
  );
};
